import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useNotifications } from "../../../../hooks/useNotifications";

const NotificationSettings = () => {
    const { notifications, getTypeConfig } = useNotifications();
    const navigate = useNavigate();
    
    // State to manage notification preferences for each notification
    const [notificationPreferences, setNotificationPreferences] = useState(
        notifications.reduce((acc, notification) => {
            acc[notification.id] = {
                email: true,
                push: true
            };
            return acc;
        }, {})
    );

    // Toggle email notification for a specific notification
    const toggleEmail = (notificationId, e) => {
        e.stopPropagation();
        setNotificationPreferences(prev => ({
            ...prev,
            [notificationId]: {
                ...prev[notificationId],
                email: !prev[notificationId]?.email
            }
        }));
    };

    // Toggle push notification for a specific notification
    const togglePush = (notificationId, e) => {
        e.stopPropagation();
        setNotificationPreferences(prev => ({
            ...prev,
            [notificationId]: {
                ...prev[notificationId],
                push: !prev[notificationId]?.push
            }
        }));
    };

    return (
        <>
            {/* Page Header */}
            <div className="container-fluid p-2 py-1">
                <div className="row mb-2">
                    <div className="col-12">
                        <div className="settings-header shadow-lg">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <h3 className="mb-2">
                                        <i className="bi bi-bell-fill me-3"></i>
                                        Notification Settings
                                    </h3>
                                    {/* <p className="mb-0 opacity-90">Manage how you receive notifications for each item</p> */}
                                </div>
                                <div className="d-flex gap-3">
                                    <div className="text-center">
                                        <div className="bg-white bg-opacity-25 rounded-3 p-2 py-1">
                                            <i className="bi bi-envelope-fill" style={{ fontSize: '1.2rem' }}></i>
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <div className="bg-white bg-opacity-25 rounded-3 p-2 py-1">
                                            <i className="bi bi-bell-fill" style={{ fontSize: '1.2rem' }}></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Notifications List */}
                {notifications.length > 0 ? (
                    <div className="row">
                        <div className="col-12">
                            <div
                                className="card border-0 shadow-lg"
                                style={{
                                    borderRadius: '0 0 24px 24px',
                                    // overflow: 'hidden',
                                    animation: 'fadeIn 0.8s ease 0.3s backwards'
                                }}
                            >
                                <div className="card-body p-0">
                                    {notifications.map((n, index) => {
                                        const relatedCfg = getTypeConfig(n.priority);
                                        const prefs = notificationPreferences[n.id] || { email: true, push: true };

                                        return (
                                            <React.Fragment key={n.id}>
                                                <div
                                                    className="notification-item p-2"
                                                    style={{
                                                        cursor: "pointer",
                                                        background: 'white',
                                                        animation: `slideInRight 0.5s ease ${index * 0.1}s backwards`
                                                    }}
                                                >
                                                    <div className="d-flex align-items-center gap-4">
                                                        {/* Icon */}
                                                        <div
                                                            className="flex-shrink-0 rounded-3 d-flex align-items-center justify-content-center"
                                                            style={{
                                                                width: '35px',
                                                                height: '35px',
                                                                background: relatedCfg.bg,
                                                                border: `2px solid ${relatedCfg.color}30`
                                                            }}
                                                        >
                                                            <i
                                                                className={`${relatedCfg.icon}`}
                                                                style={{ 
                                                                    color: relatedCfg.color,
                                                                    fontSize: '1.3rem'
                                                                }}
                                                            ></i>
                                                        </div>

                                                        {/* Title and Description */}
                                                        <div 
                                                            className="flex-grow-1 overflow-hidden"
                                                            // onClick={() => navigate(`/notification/${n.ticket_id}`)}
                                                        >
                                                            <h6 className="mb-1 fw-bold text-truncate" style={{ color: '#1e293b' }}>
                                                                {n.title}
                                                            </h6>
                                                        </div>

                                                        {/* Toggle Buttons Container */}
                                                        <div className="d-flex gap-3 flex-shrink-0">
                                                            {/* Email Toggle */}
                                                            <div className="text-center">
                                                                <button
                                                                    className={`notification-toggle-btn ${prefs.email ? 'active' : ''} p-2`}
                                                                    onClick={(e) => toggleEmail(n.id, e)}
                                                                    style={{
                                                                        width:"35px",
                                                                        height:"35px",
                                                                        borderColor: prefs.email ? '#10b981' : '#e2e8f0',
                                                                        color: prefs.email ? '#10b981' : '#94a3b8',
                                                                        background: prefs.email ? '#10b98110' : 'white'
                                                                    }}
                                                                    title={prefs.email ? 'Email enabled' : 'Email disabled'}
                                                                >
                                                                    <i className={`bi ${prefs.email ? 'bi-envelope-fill' : 'bi-envelope'}`}></i>
                                                                </button>
                                                                <small 
                                                                    className="d-block mt-1 fw-semibold" 
                                                                    style={{ 
                                                                        color: prefs.email ? '#10b981' : '#94a3b8',
                                                                        fontSize: '0.7rem'
                                                                    }}
                                                                >
                                                                </small>
                                                            </div>

                                                            {/* Push Notification Toggle */}
                                                            <div className="text-center">
                                                                <button
                                                                    className={`notification-toggle-btn ${prefs.push ? 'active' : ''} p-2`}
                                                                    onClick={(e) => togglePush(n.id, e)}
                                                                    style={{
                                                                        width:"35px",
                                                                        height:"35px",                                                                      
                                                                        borderColor: prefs.push ? '#f59e0b' : '#e2e8f0',
                                                                        color: prefs.push ? '#f59e0b' : '#94a3b8',
                                                                        background: prefs.push ? '#f59e0b10' : 'white'
                                                                    }}
                                                                    title={prefs.push ? 'Push notifications enabled' : 'Push notifications disabled'}
                                                                >
                                                                    <i className={`bi ${prefs.push ? 'bi-bell-fill' : 'bi-bell-slash'}`}></i>
                                                                </button>
                                                                <small 
                                                                    className="d-block mt-1 fw-semibold" 
                                                                    style={{ 
                                                                        color: prefs.push ? '#f59e0b' : '#94a3b8',
                                                                        fontSize: '0.7rem'
                                                                    }}
                                                                >
                                                                </small>
                                                            </div>
                                                        </div>

                                                        {/* Arrow Icon */}
                                                        <div 
                                                            className="flex-shrink-0"
                                                            // onClick={() => navigate(`/notification/${n.ticket_id}`)}
                                                        >
                                                            <i
                                                                className="bi bi-chevron-right text-muted"
                                                                style={{ fontSize: '1.3rem' }}
                                                            ></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                {index < notifications.length - 1 && (
                                                    <div className="divider"></div>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                </div>

                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="row justify-content-center">
                        <div className="col-md-6 text-center">
                            <div 
                                className="card border-0 shadow-lg p-5 rounded-4"
                                style={{
                                    animation: 'fadeIn 0.8s ease'
                                }}
                            >
                                <div className="icon-wrapper mb-4">
                                    <div 
                                        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                        style={{
                                            width: '120px',
                                            height: '120px',
                                            background: 'linear-gradient(135deg, #667eea20 0%, #764ba220 100%)',
                                            border: '3px dashed #667eea50'
                                        }}
                                    >
                                        <i className="bi bi-inbox display-1" style={{ color: '#667eea' }}></i>
                                    </div>
                                </div>
                                <h3 className="fw-bold mb-3" style={{ color: '#1e293b' }}>
                                    No Notifications Yet
                                </h3>
                                <p className="text-muted mb-4" style={{ fontSize: '1.1rem' }}>
                                    You don't have any notifications to configure at the moment.
                                </p>
                                <button
                                    className="btn btn-lg rounded-pill px-5 shadow-sm"
                                    onClick={() => navigate(-1)}
                                    style={{
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        border: 'none',
                                        fontWeight: '600',
                                        color: 'white'
                                    }}
                                >
                                    <i className="bi bi-arrow-left me-2"></i>
                                    Go Back
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default NotificationSettings;